import { render } from "./logout.vue?vue&type=template&id=d8d42b62"
import script from "./logout.vue?vue&type=script&lang=js"
export * from "./logout.vue?vue&type=script&lang=js"

import exportComponent from "/home/aloco/alocohawaii.com/moa/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__